import { render } from "./Dokumen.vue?vue&type=template&id=44a3aa3d&scoped=true"
import script from "./Dokumen.vue?vue&type=script&lang=js"
export * from "./Dokumen.vue?vue&type=script&lang=js"

import "./Dokumen.vue?vue&type=style&index=0&id=44a3aa3d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a3aa3d"]])

export default __exports__